import React from "react";
import AppView from "../../components/Layout/AppView";

const ReportsPage = () => {
  return <AppView>Reports Page</AppView>;
};

export default ReportsPage;
